export class HotkeysControllerEvents
{
    static ESCAPE: string = 'HotkeysControllerEvents.ESCAPE';
}
